import { render, staticRenderFns } from "./testPage.vue?vue&type=template&id=15597e10&scoped=true&"
import script from "./testPage.vue?vue&type=script&lang=ts&"
export * from "./testPage.vue?vue&type=script&lang=ts&"
import style0 from "../less/test.less?vue&type=style&index=0&id=15597e10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15597e10",
  null
  
)

export default component.exports